import React, { useContext } from 'react';
import Button from '../button';
import { LayoutContext } from '../layout-context-container';

function PatientButtonInterstitial({
  variant = undefined, // anchorlink, btn
  type = undefined,
  buttonUrl = '',
  customClass = undefined,
  targetBlank = true,
  useInline = false,
  preventDefault = false,
  onClick = null,
  children,
  ...rest
}) {
  const {setModalState, setModalButtonUrl, setModalTargetBlank} = useContext(LayoutContext);

  return (
    <Button
      variant={variant}
      type={type}
      buttonUrl={buttonUrl}
      externalLink={true}
      useInline={useInline}
      preventDefault={preventDefault}
      onClick={(e) => {
        onClick && onClick(e);
        
        setModalButtonUrl(buttonUrl);
        setModalTargetBlank(targetBlank);
        setModalState(true);
      }}
      customClass={`patient-button-interstitial ${customClass ?? ""}`}
      {...rest}
    >
      {children}
    </Button>
  );
}

export default PatientButtonInterstitial;